import { deepComputedFrom } from 'aurelia-deep-computed';
import { customElement } from 'aurelia-framework';
import { bindable } from 'aurelia-typed-observable-plugin';
import { watch } from 'aurelia-watch-decorator';
import { CountryVisit, initCountryVisit } from 'model/forms/travel-request';

@customElement('country-visits-panel')
export class CountryVisitsPanelCustomElement {
  @bindable items: CountryVisit[];
  private previousCountriesLength: number = null;

  bind() {
    this.previousCountriesLength = this.items.length;
  }

  @deepComputedFrom('items')
  get shouldAutoCreateCountry() {
    if (this.items == null) return false;
    const previousLength = this.previousCountriesLength;
    const currentLength = this.previousCountriesLength = this.items.length;
    if (currentLength !== previousLength || currentLength === 0) return false;
    const lastCountry = this.items[currentLength - 1];
    return lastCountry.country != null || lastCountry.transit;
  }

  @watch((x: CountryVisitsPanelCustomElement) => x.shouldAutoCreateCountry)
  private shouldAutoCreateCountryChanged(shouldAutoCreate: boolean) {
    if (shouldAutoCreate) this.addCountry();
  }

  addCountry() {
    const country = initCountryVisit();
    this.items.push(country);
  }
}
